<template>
  <div>
    <v-data-table class="elevation-1"
      :headers="headers"
      :items="items"
      :loading="loading"
      :total-items="totalItems"
      :pagination.sync="pagination"
      :no-data-text="$t('noDataAvailable')">
      <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>

      <template v-slot:items="props">
        <tr>
          <td>
            <ShipmentLink :item="props.item"></ShipmentLink>
          </td>
          <td> {{ props.item.tracking_number }} </td>
          <td> {{ props.item.overweight }} kg </td>
          <td> {{ props.item.amount | currency }} </td>
          <td> {{ $t(`list.statuses.${props.item.status}`) }} </td>
          <td> {{ props.item.created_at | date('short') }} </td>
          <td class="pa-0 pr-2 text-xs-right">
            <OverweightRowButtons :canRebate="canRebate" :overweight="props.item" @fetch="fetch"></OverweightRowButtons>
          </td>

          <td class="pa-0 pr-2 text-xs-right">
            <v-btn color="primary" outline @click="openReportOverweightDialog(props.item)">
              {{ $t('reportShipmentOverweightBtn') }}
            </v-btn>

            <v-btn color="primary" flat icon v-if="!props.expanded" @click="props.expanded = !props.expanded">
              <font-awesome-icon icon="angle-left"></font-awesome-icon>
            </v-btn>

            <v-btn color="primary" flat icon v-if="props.expanded" @click="props.expanded = !props.expanded">
              <font-awesome-icon icon="angle-down"></font-awesome-icon>
            </v-btn>
          </td>
        </tr>
      </template>

      <template v-slot:expand="props">
        <OverweightRow :overweight="props.item" @fetch="fetch"></OverweightRow>
      </template>
    </v-data-table>

    <v-dialog v-model="reportOverweightDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span v-if="selectedOverweight">
            {{ $t('reportShipmentOverweight') }} {{ selectedOverweight.shipment.sequential_id }}
          </span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-textarea v-model="reportDescription" :label="$t('attrs.description')" value=""></v-textarea>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-text-field :label="$t('selectFile')" @click="pickFile" v-model="filename" prepend-icon="attach_file"></v-text-field>
                <input type="file" style="display: none" ref="file" accept="image/*,application/pdf" @change="onFilePicked">
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" flat :disabled="reportOverweightLoading" @click="closeReportOverweightDialog">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" flat :disabled="reportOverweightLoading" @click="reportOverweight">{{ $t('reportShipmentOverweightBtn') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Overweight from '@/client/overweight'

import OverweightRow from '@/components/overweights/OverweightRowComp'
import OverweightRowButtons from '@/components/overweights/OverweightRowButtonsComp'

import ShipmentLink from '@/components/ShipmentLinkComp'

export default {
  name: "CustomerOverweightListComp",

  data () {
    return {
      headers: [
        { text: this.$tc('models.shipment'), align: 'left', sortable: false, value: 'shipment_id' },
        { text: this.$t('attrs.tracking_number'), align: 'left', sortable: false, value: 'tracking_number' },
        { text: this.$tc('models.overweight'), align: 'left', sortable: false, value: 'overweight' },
        { text: this.$t('attrs.amount'), align: 'left', sortable: false, value: 'amount' },
        { text: this.$t('attrs.status'), align: 'left', sortable: false, value: 'status' },
        { text: this.$t('attrs.created_at'), align: 'left', sortable: false, value: 'created_at' },
        { text: '', align: 'left', sortable: false, value: 'actions' },
      ],
      items: [],
      totalItems: 0,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'created_at',
        descending: true
      },
      loading: false,

      reportOverweightLoading: false,
      selectedOverweight: null,
      reportOverweightDialog: false,
      reportDescription: '',
      filename: '',
      inputFile: '',
    }
  },

  props: {
    canRebate: {
      type: Boolean,
      default: false
    },
  },

  components: {
    OverweightRow,
    OverweightRowButtons,
    ShipmentLink,
  },

  computed: {
  },

  methods: {
    async fetch () {
      this.loading = true
      const { page, rowsPerPage } = this.pagination

      const where = {}
      if (this.$route.query.shipmentId) { where.shipment_id = this.$route.query.shipmentId }
      if (this.$route.query.trackingNumber) { where.tracking_number = this.$route.query.trackingNumber }

      if (this.$route.query.carrierId || this.$route.query.serviceId) {
        where.shipments = {}

        if (this.$route.query.carrierId) {
          where.shipments.rates = {
            services: { carrier_id: this.$route.query.carrierId }
          }
        }

        if (this.$route.query.serviceId) {
          where.shipments.rates = {
            service_id: this.$route.query.serviceId
          }
        }
      }

      const obj = { page, per_page: rowsPerPage, where }

      this.items = await Overweight.all(obj)
      this.totalItems = this.items.pagination.total_objects
      this.loading = false
    },

    openReportOverweightDialog(overweight) {
      this.selectedOverweight = overweight
      this.reportDescription = overweight.evidence_description
      this.inputFile = ''
      this.filename = ''
      this.reportOverweightDialog = true
    },

    closeReportOverweightDialog() {
      this.selectedOverweight = null
      this.reportOverweightDialog = false
    },

    onFilePicked (e) {
      this.loading = true
      this.errors.clear()

      this.inputFile = e.target.files[0]
      this.filename = this.inputFile.name
      this.loading = false
    },

    pickFile () {
      this.$refs.file.click()
    },

    async reportOverweight() {
      if (!this.selectedOverweight) { return }
      if (!this.reportDescription) { return }
      if (!this.inputFile) { return }

      this.reportOverweightLoading = true
      try {
        const formData = new FormData()
        formData.append('overweight[evidence_file]', this.inputFile)
        formData.append('overweight[evidence_description]', this.reportDescription)
        await this.selectedOverweight.updateEvidence(formData)

        this.setNotification({
          color: 'success',
          message: this.$t('overweightReportedSuccessfully')
        })
        this.fetch()
        this.closeReportOverweightDialog()
      } catch (err) {
        this.handleErr(err)
      }
      this.reportOverweightLoading = false
    },
  },

  watch: {
    pagination: {
      handler () {
        this.fetch()
      },
      deep: true
    },
  },

  mounted () {
    this.fetch()
  }
}
</script>
